import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0ed696b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tags__view"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tag__cycle"
}, null, -1));

const _hoisted_3 = {
  class: "tag__text"
};
const _hoisted_4 = ["onClick"];
import { ref, nextTick } from 'vue';
import { useCommon } from '@/store/useCommon';
import { useRoute, useRouter } from 'vue-router';
import { Storage } from '@/utils/tools';
const __default__ = {
  name: 'TagsView'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const storeCommon = useCommon();
    const visible = ref(false);
    const left = ref(0);
    const top = ref(0);
    let selectedTag = ref(null);
    const viewItemsRef = ref(null);
    const tagsInnerRef = ref(null);
    const tagsLeft = ref(0);
    const tags = computed(() => storeCommon.visitedViews);
    const isCollapse = computed(() => storeCommon.isCollapse);

    const openedStateChange = () => {
      storeCommon.changeCollapse(!isCollapse.value);
    };

    const roRight = offset => {
      const scrollLeft = viewItemsRef.value.scrollLeft;
      viewItemsRef.value.scrollLeft = scrollLeft + offset;
    }; // 鼠标右键事件，弹出菜单


    const onOpenMenu = (tag, e) => {
      left.value = e.clientX;
      top.value = e.clientY;
      visible.value = true;
      selectedTag.value = tag;
    }; // 高亮当前标签


    const isActive = r => {
      return r.path === route.path;
    }; // 处理当前标签是最后一个标签页的情况


    const toLastView = (visitedViews, view) => {
      const latestView = visitedViews.slice(-1)[0];

      if (latestView) {
        router.push({
          path: latestView.path,
          query: latestView.query,
          params: latestView.params
        });
      } else {
        router.push('/');
      }
    }; // 关闭标签


    const closeSelectedTag = view => {
      storeCommon.delTagsView(view ? { ...view
      } : selectedTag);

      if (isActive(view)) {
        toLastView(storeCommon.visitedViews, view);
      }
    };

    const closeMenu = () => {
      console.log('close');
      visible.value = false;
    }; // 刷新当前标签


    const refreshSelectedTag = () => {
      storeCommon.clearIncludePage(selectedTag.value.name);
      router.push({
        path: selectedTag.value.path
      });
      setTimeout(() => {
        storeCommon.refreshCurrentPage(route.name);
      }, 100);
    }; // 关闭其他标签


    const closeOthersTags = view => {
      storeCommon.delOtherView(selectedTag.value);
      router.push(selectedTag.value.path);
    }; // 关闭所有标签


    const closeAllTags = () => {
      storeCommon.delAllTagsView();
      storeCommon.resetIncludePage();
      router.push('/');
    };

    watch(visible, val => {
      if (val) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    watch(() => route.path, val => {
      storeCommon.addTagsView({ ...route
      });
      const cacheType = 'cms';
      let cacheRoutes = Storage.sessionGet('cacheRoutes') || {
        cms: "/cms",
        main: '/',
        amk: '/amk/welcome',
        record: '/liveRecord',
        dstc: '/dstc',
        epg: '/epg',
        dataService: '/data-service'
      }; // Storage.sessionSet('cacheRoutes', {
      //   ...cacheRoutes,
      //   [cacheType]: '/cms' + route.fullPath,
      // })

      nextTick(() => {
        if (storeCommon.cacheData.PLATFORM_TYPE == 'cms') {
          // 获取当前的路由tab标签dom
          let item = tagsInnerRef.value.querySelectorAll('a.active')[0]; // console.log(viewItemsRef.value.offsetWidth,viewItemsRef.value.scrollLeft, item.offsetLeft)

          if (item) {
            const halfWidth = viewItemsRef.value.offsetWidth / 2;

            if (item.offsetLeft > halfWidth) {
              viewItemsRef.value.scrollLeft = item.offsetLeft - halfWidth;
            } else {
              viewItemsRef.value.scrollLeft = item.offsetLeft;
            }
          }
        }
      });
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "view__collapse",
        onClick: openedStateChange
      }, [_createElementVNode("i", {
        class: _normalizeClass(["iconfont fs--16", [_unref(isCollapse) ? 'icon-expand' : 'icon-retract']])
      }, null, 2)]), _createElementVNode("i", {
        class: "view__left-icon iconfont icon-normal",
        onClick: _cache[0] || (_cache[0] = $event => roRight(-240))
      }), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "view__items",
        ref_key: "viewItemsRef",
        ref: viewItemsRef
      }, [_createElementVNode("div", {
        class: "items__tags-inner",
        ref_key: "tagsInnerRef",
        ref: tagsInnerRef,
        style: _normalizeStyle({
          left: tagsLeft.value + 'px'
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), tag => {
        return _openBlock(), _createBlock(_component_router_link, {
          key: tag.path,
          ref_for: true,
          ref: "itemTagRef",
          class: _normalizeClass(["items__tag", {
            active: isActive(tag)
          }]),
          to: {
            path: tag.path,
            query: tag.query
          },
          onContextmenu: _withModifiers($event => onOpenMenu(tag, $event), ["prevent"])
        }, {
          default: _withCtx(() => [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(tag.meta.title)), 1), _createElementVNode("i", {
            class: "iconfont icon-cuo tag__del",
            onClick: _withModifiers($event => closeSelectedTag(tag), ["prevent", "stop"])
          }, null, 8, _hoisted_4)]),
          _: 2
        }, 1032, ["class", "to", "onContextmenu"]);
      }), 128)), _withDirectives(_createElementVNode("ul", {
        style: _normalizeStyle({
          left: left.value + 'px',
          top: top.value + 'px'
        }),
        class: "items__tag-menu"
      }, [_createElementVNode("li", {
        onClick: refreshSelectedTag
      }, _toDisplayString(_ctx.$t('刷新')), 1), _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = $event => closeSelectedTag(_unref(selectedTag)))
      }, _toDisplayString(_ctx.$t('关闭')), 1), _createElementVNode("li", {
        onClick: closeOthersTags
      }, _toDisplayString(_ctx.$t('关闭其他')), 1), _createElementVNode("li", {
        onClick: closeAllTags
      }, _toDisplayString(_ctx.$t('关闭全部')), 1)], 4), [[_vShow, visible.value]])], 4)])), [[_directive_crosswiseScroll]]), _createElementVNode("i", {
        class: "view__right-icon iconfont icon-ic_chevron_right_px",
        onClick: _cache[2] || (_cache[2] = $event => roRight(240))
      })]);
    };
  }

});